import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const HotjarPixel: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    if (!landingPage.integrations.hotjarPixelId) return null

    return (
        <Script id="hotjar-tracking" strategy="afterInteractive">
            {`
                (function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:${landingPage.integrations.hotjarPixelId},hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            `}
        </Script>
    )
}
